import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
var StringArrayToTitle = function (props) {
    var strArray = props.strArray;
    return (React.createElement("div", { "data-id": "StringArrayToTitle", className: "sui-flex sui-flex-col sui-gap-0 sm:sui-flex-row sm:sui-gap-2" },
        React.createElement("span", null, strArray[0]),
        React.createElement("span", null, strArray[1])));
};
export var ComponentHeading = function (props) {
    var title = props.title, titleArray = props.titleArray, subtitle = props.subtitle, isMobile = props.isMobile;
    var variant = isMobile ? 'h1' : 'h2';
    var TitleArray = function () {
        return titleArray ? React.createElement(StringArrayToTitle, { strArray: titleArray }) : React.createElement(React.Fragment, null);
    };
    var SubTitle = function () { return (React.createElement("div", { className: "sui-pt-2" },
        React.createElement(Typography, null, subtitle))); };
    return (React.createElement("div", { "data-id": "ComponentHeading", className: "sui-mb-12 sui-mt-12 sm:sui-mt-0" },
        React.createElement(Typography, { variant: variant, weight: "display" },
            !!title && title,
            !!titleArray && React.createElement(TitleArray, null)),
        !!subtitle && React.createElement(SubTitle, null)));
};
